import React, { useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Icon from "components/AppIcon";
import { useLanguage } from "../LanguageContext"; // Adjust the import path
import Image from "components/AppImage";

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { language, direction } = useLanguage();
  const sidebarRef = useRef(null); // Create a ref for the sidebar

  const isArabic = language === "ar";

  const translations = {
    dashboardOverview: isArabic
      ? "نظرة عامة على لوحة التحكم"
      : "Dashboard Overview",
    clientManagement: isArabic ? "إدارة العملاء" : "Client Management",
    categories: isArabic ? "الفئات" : "Categories",
    adminAccounts: isArabic ? "حسابات الإدارة" : "Admin Accounts",
    departments: isArabic ? "الأقسام" : "Departments",
    contact_us: isArabic ? "تواصل معنا" : "Contact Us",
    governoratesManagement: isArabic ? "المحافظات" : "governorates",
    servicesManagement: isArabic ? "الخدمات" : "services",
    logout: isArabic ? "تسجيل الخروج" : "Logout",
    appointmentsManagement: isArabic ? "المواعيد" : "Appointments",
  };

  const navigationItems = [
    {
      name: translations.dashboardOverview,
      path: "/dashboard-overview",
      icon: "BarChart3",
    },
    /* {
      name: translations.clientManagement,
      path: "/client-management",
      icon: "Users",
    },*/
    {
      name: translations.governoratesManagement,
      path: "/governorates-management",
      icon: "Governorates",
    },
    {
      name: translations.servicesManagement,
      path: "/services-management",
      icon: "services",
    },
    {
      name: translations.appointmentsManagement,
      path: "/appointments-management",
      icon: "appointments",
    },
    {
      name: translations.categories,
      path: "/categories",
      icon: "User  Plus",
    },
    /*   {
      name: translations.adminAccounts,
      path: "/admin-account-management",
      icon: "Shield",
    },*/
  ];

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  return (
    <div
      ref={sidebarRef} // Attach the ref to the sidebar
      className={`fixed inset-y-0 ${
        direction === "rtl" ? "right-0" : "left-0"
      } z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out lg:translate-x-0 ${
        isOpen ? "translate-x-0" : "-translate-x-full"
      }`}
    >
      <div className="flex items-center justify-between h-16 px-6">
        <div className="flex items-center">
          <div className="w-14 h-14 flex items-center justify-center">
            <Image
              src="/assets/images/logo_2.jpg"
              alt=""
              className="w-full h-70 object-cover rounded-lg shadow-lg"
            />
          </div>
          <span className="ml-2 text-xl font-bold text-gray-900">ارتاح</span>
        </div>
        <button
          onClick={onClose}
          className="lg:hidden p-1 rounded-md text-gray-400 hover:text-gray-600"
        >
          <Icon name="X" size={20} />
        </button>
      </div>

      <nav className="mt-6 px-3">
        <div className="space-y-1">
          {navigationItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                onClick={onClose}
                className={`flex items-center px-3 py-2 text-sm font-medium rounded-lg transition-colors duration-200 ${
                  isActive
                    ? "bg-green-100 text-green-700 border-r-2 border-green-600"
                    : "text-gray-600 hover:bg-gray-100 hover:text-gray-900"
                }`}
              >
                <Icon name={item.icon} size={20} className="mr-3 ml-3" />
                {item.name}
              </Link>
            );
          })}
        </div>
      </nav>

      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
        <Link
          to="/admin-login"
          className="flex items-center px-3 py-2 text-sm font-medium text-red-600 rounded-lg hover:bg-red-50 transition-colors duration-200"
        >
          <Icon name="LogOut" size={20} className="mr-3" />
          {translations.logout}
        </Link>
      </div>
    </div>
  );
};

export default Sidebar;
